import { isGroupfolioEntityType } from '@upright/common/model/input/groupfolios/types';
import { Valence } from '@upright/common/model/types';
import { ElbowConnector } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/elbow-connector';
import {
  getAllBarBounds,
  getBoundsWithVerticalIntersect,
} from '@upright/ui/common/upright/core/impact-lens-profile/common/components/connectors/utils';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { valenceToSide } from '@upright/ui/common/upright/core/impact-lens-profile/common/utils';
import { useCarouselLayout, useImpactBarsLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { useNetImpactLensContext } from '@upright/ui/common/upright/core/impact-lenses/net-impact/common/use-net-impact-lens-context';
import { max, min } from 'lodash';

export function SingleImpactInfoBoxConnector() {
  const context = useNetImpactLensContext();
  const baseLayout = useCarouselLayout();
  const layout = useImpactBarsLayout();

  if (!context) {
    return <></>;
  }

  const data = context.data;
  const selection = context.state;
  const valence = selection.valence;
  const impact = selection.impact;
  const scores = data?.scores;

  if (!data || !data.entity || !scores || !impact || !valence || baseLayout.boxMode !== LensBoxMode.SIDE) {
    return <></>;
  }

  // See note in key-takeaway-connector.tsx — the elbow only needs to clear
  // percentile labels. Two cases force the suffix on: the user toggle, or a
  // groupfolio entity (the outside label always shows `(top X%)` for the
  // highlighted top impacts on group / portfolio pages).
  const showPercentiles = context.state.showCategoryPercentiles ?? false;
  const isGroupfolio = isGroupfolioEntityType(data.entity.type);
  const labelMargin = showPercentiles || isGroupfolio ? 30 : 0;

  const ia = layout.impactBarAndLabelArea(valenceToSide(valence), impact);
  const x2 = valence === Valence.POSITIVE ? ia.x2 : ia.x1;
  const y2 = ia.cy;

  const ba = baseLayout.boxesArea(valenceToSide(valence));
  const x1 = valence === Valence.POSITIVE ? ba.x1 : ba.x2;
  const y1 = ba.cy;

  // TODO: fix & refactor
  const barBounds = getAllBarBounds(layout, valenceToSide(valence));
  const intersectingBounds = getBoundsWithVerticalIntersect(barBounds, [{ y1, y2 }]);
  const midXValues = intersectingBounds.map(bounds => {
    const barEndX = valence === Valence.NEGATIVE ? bounds.x1 : bounds.x2;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return (barEndX + x1) / 2;
  });

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const branchX = valence === Valence.NEGATIVE ? min(midXValues)! : max(midXValues)!;

  return <ElbowConnector x1={x1} x2={x2} y1={y1} y2={y2} branchX={branchX} addedHorizontalMargin={labelMargin} />;
}
